import React from "react";
import { useSelector } from "react-redux";
import Widget from "../../features/widget/Widget";
import { resolveBucketImageSrc } from "../../../utils/utils";
import classes from "./SchoolLogoWidget.module.css";

const SchoolLogoWidget = () => {

    const schoolData = useSelector(state => state.auth?.userDetails?.defaultSchool);

    return (
        <Widget
            className={classes.SchoolLogoWidget}
        >
            <div className={classes.SchoolLogoContent}>
                <img src={resolveBucketImageSrc(schoolData?.iconUrl)} alt={schoolData?.name} className={classes.SchoolLogo} />
            </div>
        </Widget>
    );
};

export default SchoolLogoWidget;
